import { useState } from 'react';
import s from './students-list.module.scss'
import classNames from 'classnames'
import { IconPlus, IconSearch } from '@tabler/icons-react';
import { FormProvider, useForm } from 'react-hook-form'
import { AnimatePresence } from 'framer-motion'
import { useMyStudents } from '@features/teacher/add-appointment-by-teacher/api/useMyStudents';
import { getFullName } from '@utils/lib/getFullname';
import { FetchingDiv } from '@shared/ui/fetching-div/fetching-div';
import { Input } from '@shared/ui/input/input';
import { Button } from '@shared/ui/button/button';
import { useConnectStudentModal } from '@features/teacher/connect-student/model/use-connect-student-modal';
import { StudentCard } from '../student-card/student-card';
import { TZDate } from '@date-fns/tz';
import { queryClient } from '@shared/api/query-client';

const months = [
	"января",
	"февраля",
	"марта",
	"апреля",
	"мая",
	"июня",
	"июля",
	"августа",
	"сентября",
	"октября",
	"ноября",
	"декабря",
];

export const StudentsList = ({className, compact}) => {
	const {data: students, isLoading} = useMyStudents()
	const {data: profile} = queryClient.getQueryData(['profile'])
	
	const {open: openModal} = useConnectStudentModal()
	const [searchValue, setSearchValue] = useState('')
	
	const methods = useForm()
	const { handleSubmit} = methods

	const onSubmit = handleSubmit(data => {		
		setSearchValue(data?.q)
	})

	const filterStudents = (students, searchQuery) => {
		return students?.filter(student => {
			const fullName = student?.student_id ? getFullName(student?.student) : null;
			
			return fullName?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
			student?.student?.email?.toLowerCase().includes(searchQuery.toLowerCase()) || student?.student_email?.toLowerCase().includes(searchQuery.toLowerCase());
		});
	};

	const filteredStudents = filterStudents(students, searchValue);

	return (
    <FetchingDiv className={classNames(className, s.card, compact && s.compact)} isFetching={isLoading}>
			<div className={s.header}>
        {!compact && <div className={s.title}>Мои ученики</div>}
        <FormProvider {...methods}>
          <Input
            placeholder="Поиск"
            leftIcon={<IconSearch size={18} className={s.searchBtn}/>}
            name="q"
            className={s.input}
            onBlur={onSubmit}
            onKeyPress={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                onSubmit();
              }
            }}
          />
        </FormProvider>
        <Button
          className={s.addBtn}
          theme="secondary"
          label={<div className={s.label}><IconPlus size={16} strokeWidth={3}/>Добавить ученика</div>}
          onClick={() => openModal()}
        />
      </div>
      {students?.length > 0 ? (
       filteredStudents.length > 0 ? 
				<div className={s.scroller}>
            <div className={s.list}>
							<AnimatePresence>
								{filteredStudents?.map(
									({ student, student_id, student_email, id }) => {
										const isRegistered = !!student_id
										const date = new TZDate(student?.upcoming_appointment?.starts_at, profile?.timezone)

										return <StudentCard key={'student-' + id} {...{isRegistered, id, date, student, student_email, months}}/>;
									}
								)}
							</AnimatePresence>
            </div>
          </div> : 
				 <div className={s.notFound}>У вас нет такого ученика</div>
      ) : (
        <div className={s.notFound}>У вас пока нет учеников, но это легко исправить...</div>
      )}
    </FetchingDiv>
  );
}